import { useEffect, useState } from 'react';
import { endpoint } from './api';

/**
 * 공개 악보 수(100곡 단위로 내림) — '6,600곡이 넘는' 같은 문구용. 서버가 1시간마다 다시 셈(/api/score-count).
 * 받기 전이나 실패하면 FALLBACK 을 쓴다. 공통 오류 경고창(api 인스턴스)을 띄우지 않도록 fetch 로 부른다.
 */
const FALLBACK = 6600;
let cache: Promise<number> | null = null;

export const useScoreCount = () => {
  const [n, setN] = useState(FALLBACK);
  useEffect(() => {
    let alive = true;
    if (!cache) {
      cache = fetch(`${endpoint}/score-count`)
        .then((r) => (r.ok ? r.json() : null))
        .then((d) => Number(d?.data?.count) || FALLBACK)
        .catch(() => FALLBACK);
    }
    cache.then((v) => alive && setN(v));
    return () => {
      alive = false;
    };
  }, []);
  return n.toLocaleString();
};
